<micro-lookup domain="ai" obj="bts" url="/ai/bts" [key]="aiBtId"></micro-lookup>
